import { Component, OnInit, HostListener, ElementRef, ViewChild } from '@angular/core';
import { Covid19Batch } from '../agptesting-newview/model/covid19Batch';
import { SenderDTO } from '../masterdata/models/sender-dto';
import { MessagesService } from '../messages/messages.service';
import { CustomerTrackService } from './customer-track.service';
import { ErrorHandler } from '../utils/error-handler';
import { DatePipe } from '@angular/common';
import { AuthUtil } from '../common-services/auth-util';
import * as jwt_decode from 'jwt-decode';
import { saveAs as saveByFileSaver } from "file-saver";

@Component({
  selector: 'app-customer-track',
  templateUrl: './customer-track.component.html',
  styleUrls: ['./customer-track.component.css']
})
export class CustomerTrackComponent implements OnInit {

  @ViewChild('topDiv',{static : false}) elementView: ElementRef;
  errorHandler: ErrorHandler = new ErrorHandler;

  selectedLab:any;
  selectedLabId: string;
  searchFilterList:any[];
  searchSenderList:any[] = [];
  searchstatusList:any[];
  selectedBatch: Covid19Batch;
  puid: string;
  selectedSearchFilter:any;
  valueToSearch : string;
  valueToSearchforSender: string;
  valueToSearchforStatus: string;
  fromDate: Date;
  toDate: Date;

  isSelected:any;
  populateTableData: any[] = [];
  scrollableCols: any[];
  mapOfSenders = new Map();
  selectedSender: SenderDTO;
  customerBarcodeAllowed = false;
  documentBarcodeAllowed = false;
  boxIdScanAllowed = false;
  includeInvoicedBatches:boolean=false;
  blocked: boolean = false;
  validRole:boolean;
  mapOfStatusCalls = new Map();
  senderListForPopulateData:any[]=[];
  notificationOfMoreData:boolean=false;
  statusDisabled:boolean =true;

  customerExport:boolean=false;
  setRowdataforExport:any[] = [];
  setParsedRowData:any[]=[];
  listOfFile:any;
  selectedBatches: any[]=[];
  rowDataCheck:boolean=true;
  senderDataCheck:boolean=false;
  downloadOption:string;
  selectedRows: any[];
  divHeight: number;
  scrollHeight: string;
  readonly blueberryArticKonstanzInvoicingUsers = 'BlueberryArticKonstanzInvoicingUsers';
  readonly blueberryUKDTCPopGenInvoicingUsers ='BlueberryUKDTCPopGenInvoicingUsers';
  dateFormat: string;

  constructor(private _messagesService: MessagesService,private customerTrackService:CustomerTrackService,private datepipe: DatePipe) { }

  setDateFormat(dateFormat){
    return   dateFormat.length>8  ? dateFormat.replace("yyyy","yy"): dateFormat.replace("yy","y");
  }

  ngOnInit() {
    this.selectedBatch = new Covid19Batch();
    this.selectedLab = JSON.parse(localStorage.getItem('lab'));
    this.selectedLabId = this.selectedLab .lab._id;
    this.dateFormat = this.setDateFormat(this.selectedLab.lab.dateFormat.toLowerCase());
    
    this.puid = localStorage.getItem('PUID');
    this.validRole = this.decideIfBBRoleExists();
    this.scrollableCols = [
      { 'header': 'Batch ID', 'field': 'batchID', 'selected': false },
      { 'header': 'External ID', 'field': 'externalId', 'selected': false },
      { 'header': 'Sender Short Name', 'field': 'sender', 'selected': false },
      { 'header': 'Library ID', 'field': 'libraryId', 'selected': false },
      { 'header': 'Delivery Target Date', 'field': 'deliveryTargetDateTime' , 'selected': false},
      { 'header': 'Received Date', 'field': 'batchReceivedDateTime' , 'selected': false},
      { 'header': 'Delivery Date ', 'field': 'deliveryDate', 'selected': false },
      { 'header': 'Actual Status(Date)', 'field': 'statusOfTheBatch', 'selected': false },
      { 'header': 'No. of Samples', 'field': 'sampleCount' , 'selected': false},
      { 'header': 'No. of Drop Outs', 'field': 'dropOutsSamples' , 'selected': false},
      { 'header': 'No. of QC Failed ', 'field': 'lineageFailedCount', 'selected': false },
      { 'header': 'No. of Qualitative Samples', 'field': 'highQualitySamples' , 'selected': false}
    ]
    if(this.validRole){
        this.scrollableCols.push({ 'header': 'No. of Billable', 'field': 'billableSamples' , 'selected': false});
        this.scrollableCols.push({ 'header': 'Unit Price [EUR]', 'field': 'unitPrice' , 'selected': false});
        this.scrollableCols.push({ 'header': 'Total Price [EUR]', 'field': 'totalPrice' , 'selected': false});
    }
    this.searchFilterList = [
      {label:'Batch Id',value:'BatchId'},
      {label:'Sample Id',value:'SampleId'},
      {label:'External Id',value:'ExternalId'}
    ];
    
    this.searchstatusList = [
      { label: 'Create Batch', value: "CREATE_BATCH" },
      { label: 'Upload Batch', value: "BATCH_UPLOADED" },
      { label: 'Receive Batch', value: "BATCH_RECEIVED" },
      { label: 'Controls Added', value: "CONTROLS_ADDED" },
      { label: 'Start cDNA', value: "START_cDNA" },
      { label: 'Complete cDNA', value: "COMPLETE_cDNA" },
      { label: 'Start Artic PCR', value: "START_ARTIC_PCR" },
      { label: 'Complete Artic PCR', value: "COMPLETE_ARTIC_PCR" },
      { label: 'Start ARTIC Pooling', value: "START_ARTIC_POOLING" },
      { label: 'Complete ARTIC Pooling', value: "COMPLETE_ARTIC_POOLING" },
      { label: 'Start ARTIC Purification', value: "START_ARTIC_PURIFICATION" },
      { label: 'Complete ARTIC Purification', value: "COMPLETE_ARTIC_PURIFICATION" },
      { label: 'Start Artic QC', value: "START_ARTIC_QC" },
      { label: 'Complete Artic QC', value: "COMPLETE_ARTIC_QC" },
      { label: 'Start Normalization', value: "START_NORMALIZATION" },
      { label: 'Complete Normalization', value: "COMPLETE_NORMALIZATION" },
      { label: 'Start End Repair', value: "START_END_REPAIR" },
      { label: 'Complete End Repair', value: "COMPLETE_END_REPAIR" },
      { label: 'Start Adapter Ligation', value: "START_ADAPTER_LIGATION" },
      { label: 'Complete Adapter Ligation', value: "COMPLETE_ADAPTER_LIGATION" },
      { label: 'Start Purification 2', value: "START_PURIFICATION_2" },
      { label: 'Complete Purification 2', value: "COMPLETE_PURIFICATION_2" },
      { label: 'Start Tag PCR', value: "START_TAG_PCR" },
      { label: 'Complete Tag PCR', value: "COMPLETE_TAG_PCR" },
      { label: 'Start Lib QC', value: "START_LIB_QC" },
      { label: 'Complete Lib QC', value: "COMPLETE_LIB_QC" },
      { label: 'Start Lib Pooling', value: "START_LIB_POOLING" },
      { label: 'Complete Lib Pooling', value: "COMPLETE_LIB_POOLING" },
      { label: 'Start Final QC', value: "START_FINAL_QC" },
      { label: 'Complete Final QC', value: "COMPLETE_FINAL_QC" },
      { label: 'Transfer To Sequencing', value: "TRANSFER_SEQUENCING" },
      { label: 'Start Sequencing Run', value: "START_SEQUENCING_RUN" },
      { label: 'Complete Sequencing Run', value: "COMPLETE_SEQUENCING_RUN" },
      { label: 'Start Primary Analysis', value: "START_PRIMARY_ANALYSIS" },
      { label: 'Complete Primary Analysis', value: "COMPLETE_PRIMARY_ANALYSIS" },
      { label: 'Start Secondary Analysis', value: "START_SECONDARY_ANALYSIS" },
      { label: 'Complete Secondary Analysis', value: "COMPLETE_SECONDARY_ANALYSIS" },
      { label: 'Start Data Review', value: "START_DATA_REVIEW" },
      { label: 'Ready For Delivery', value: "READY_FOR_DELIVERY" },
      { label: 'Start Delivery', value: "START_DELIVERY" },
      { label: 'Delivered', value: "COMPLETED" },
      { label: 'Invoiced', value: "INVOICED" },
      { label: 'Redo', value: "REDO" },
      { label: 'Removed', value: "REMOVED" },
      { label: 'Archived', value: "ARCHIVED" }
    ];

    this.mapOfStatusCalls.set("CREATE_BATCH", "Create Batch");
    this.mapOfStatusCalls.set( "BATCH_UPLOADED" , 'Upload Batch')
    this.mapOfStatusCalls.set( "BATCH_RECEIVED" , 'Receive Batch')
    this.mapOfStatusCalls.set( "CONTROLS_ADDED" , 'Controls Added')
    this.mapOfStatusCalls.set( "START_cDNA" , 'Start cDNA')
    this.mapOfStatusCalls.set( "COMPLETE_cDNA" , 'Complete cDNA')
    this.mapOfStatusCalls.set( "START_ARTIC_PCR" , 'Start Artic PCR')
    this.mapOfStatusCalls.set( "COMPLETE_ARTIC_PCR" , 'Complete Artic PCR')
    this.mapOfStatusCalls.set( "START_ARTIC_POOLING" , 'Start ARTIC Pooling')
    this.mapOfStatusCalls.set( "COMPLETE_ARTIC_POOLING" , 'Complete ARTIC Pooling')
    this.mapOfStatusCalls.set( "START_ARTIC_PURIFICATION" , 'Start ARTIC Purification')
    this.mapOfStatusCalls.set( "COMPLETE_ARTIC_PURIFICATION" , 'Complete ARTIC Purification')
    this.mapOfStatusCalls.set( "START_ARTIC_QC" , 'Start Artic QC')
    this.mapOfStatusCalls.set( "COMPLETE_ARTIC_QC" , 'Complete Artic QC')
    this.mapOfStatusCalls.set( "START_NORMALIZATION" , 'Start Normalization')
    this.mapOfStatusCalls.set( "COMPLETE_NORMALIZATION" , 'Complete Normalization')
    this.mapOfStatusCalls.set( "START_END_REPAIR" , 'Start End Repair')
    this.mapOfStatusCalls.set( "COMPLETE_END_REPAIR" , 'Complete End Repair')
    this.mapOfStatusCalls.set( "START_ADAPTER_LIGATION" , 'Start Adapter Ligation')
    this.mapOfStatusCalls.set( "COMPLETE_ADAPTER_LIGATION" , 'Complete Adapter Ligation')
    this.mapOfStatusCalls.set( "START_PURIFICATION_2" , 'Start Purification 2')
    this.mapOfStatusCalls.set( "COMPLETE_PURIFICATION_2" , 'Complete Purification 2')
    this.mapOfStatusCalls.set( "START_TAG_PCR" , 'Start Tag PCR')
    this.mapOfStatusCalls.set( "COMPLETE_TAG_PCR" , 'Complete Tag PCR')
    this.mapOfStatusCalls.set( "START_LIB_QC" , 'Start Lib QC')
    this.mapOfStatusCalls.set( "COMPLETE_LIB_QC" , 'Complete Lib QC')
    this.mapOfStatusCalls.set( "START_LIB_POOLING" , 'Start Lib Pooling')
    this.mapOfStatusCalls.set( "COMPLETE_LIB_POOLING" , 'Complete Lib Pooling')
    this.mapOfStatusCalls.set( "START_FINAL_QC" , 'Start Final QC')
    this.mapOfStatusCalls.set( "COMPLETE_FINAL_QC" , 'Complete Final QC')
    this.mapOfStatusCalls.set( "TRANSFER_SEQUENCING" , 'Transfer To Sequencing')
    this.mapOfStatusCalls.set( "START_SEQUENCING_RUN" , 'Start Sequencing Run')
    this.mapOfStatusCalls.set( "COMPLETE_SEQUENCING_RUN" , 'Complete Sequencing Run')
    this.mapOfStatusCalls.set( "START_PRIMARY_ANALYSIS" , 'Start Primary Analysis')
    this.mapOfStatusCalls.set( "COMPLETE_PRIMARY_ANALYSIS" , 'Complete Primary Analysis')
    this.mapOfStatusCalls.set( "START_SECONDARY_ANALYSIS" , 'Start Secondary Analysis')
    this.mapOfStatusCalls.set( "COMPLETE_SECONDARY_ANALYSIS" , 'Complete Secondary Analysis')
    this.mapOfStatusCalls.set( "START_DATA_REVIEW" , 'Start Data Review')
    this.mapOfStatusCalls.set( "READY_FOR_DELIVERY" , 'Ready For Delivery')
    this.mapOfStatusCalls.set( "START_DELIVERY" , 'Start Delivery')
    this.mapOfStatusCalls.set( "COMPLETED" , 'Delivered')
    this.mapOfStatusCalls.set( "INVOICED" , 'Invoiced')
    this.mapOfStatusCalls.set( "REDO" , 'Redo')
    this.mapOfStatusCalls.set( "REMOVED" , 'Removed')
    this.mapOfStatusCalls.set( "ARCHIVED" , 'Archived')


    this.selectedSearchFilter = "BatchId"
    this.populateSendersInMap();
    this.onResize();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event?) {
    if (this.elementView != undefined) {
      this.scrollHeight = document.documentElement.clientHeight - this.elementView.nativeElement.offsetHeight - document.getElementById("header").offsetHeight - 150+ 'px';
      this.divHeight = window.innerHeight - this.elementView.nativeElement.offsetHeight - document.getElementById("header").offsetHeight-150;
    }
  }
  searchForBatchWIthFilter(){
    if(!this.valueToSearch || this.valueToSearch.trim() ==''){
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Value Not Entered', detail: 'Please Enter the value to search.' });
    }
  }
  searchButtonDisabledIf(){
    return !(this.selectedSearchFilter && this.valueToSearch && this.valueToSearch.trim() != '' );
  }
  senderButtonDisabledIf(){
    return !(this.valueToSearchforSender);
  }
  senderstatusButtonDisabledIf(){
    return !(this.valueToSearchforStatus);
  }
  onApplyFilter(data:any) {
    this.senderListForPopulateData = data.value;
  }
  populateSendersInMap() {
    this.blocked = true;
    this.customerTrackService.getMapOfSenders(this.selectedLabId, true).subscribe(
      result => {
        if (result.data) {
          Object.entries(result.data).forEach(([key, value]) => {
            this.mapOfSenders.set(key, value);
            let tempSender:any = value;
            let labelValue = tempSender.senderShortName ? tempSender.senderShortName : key;
            this.searchSenderList.push({ label: labelValue, value: key });
          });
          this.setBatchSender();
          this.selectedSender = this.mapOfSenders.get(this.searchSenderList[0].value);
          if(this.searchSenderList.length==1){
          this.selectedBatch.swabType= this.selectedSender.swabType;
          }
          this.searchSenderList.sort((a,b) => a.label.localeCompare(b.label));
          this.setVisibilityForDocumentAndExternalBarcodes();
        }
        this.blocked = false;
      },
      error => {
        this.handleError(error);
      }
    );
  }
  setBatchSender() {
    if(this.searchSenderList.length == 1) {
      this.selectedBatch.sender = this.searchSenderList[0].value;
      
    } else {
      this.selectedBatch.sender = null;
    }
  }
  setVisibilityForDocumentAndExternalBarcodes() {
    this.boxIdScanAllowed = this.selectedSender.boxBarcode == 'Not Used' ? false : true;
    this.documentBarcodeAllowed = this.selectedSender.trfBarcode == 'Not Used' ? false : true;
    this.customerBarcodeAllowed = this.selectedSender.externalSampleBarcode == 'Not Used' ? false : true;
  }
  getAllTableData(){
    if(!this.validation()){
      return;
    }
    this.notificationOfMoreData=false;
    this.blocked = true;
    let toFilterDate: Date;
    if(this.toDate){
      toFilterDate = new Date(this.toDate.getTime());
      toFilterDate.setDate(toFilterDate.getDate() + 1)
    }
    let dataToExport = {"puid": this.puid, "filterType":this.selectedSearchFilter, "filterValue": this.valueToSearch?this.valueToSearch.trim():this.valueToSearch,"senders": this.senderListForPopulateData,
    "status": this.valueToSearchforStatus,"fromDate":this.fromDate?this.fromDate.toDateString():"","toDate":toFilterDate?toFilterDate.toDateString():"","includeInvoicedBatches":this.includeInvoicedBatches,
  "validRole":this.validRole};
    let jsonString:string= JSON.stringify(dataToExport);
    this.populateTableData = [];
    this.customerTrackService.getBatches(this.selectedLabId, jsonString).subscribe(
      result => {
        this.setProperties(result);
        this.blocked = false;
      },
      error => {
        this.handleError(error);
      });
    
  }

  private validation(){
    let filterValue = this.valueToSearch ? this.valueToSearch.trim() : this.valueToSearch;
    if(!filterValue && !(this.senderListForPopulateData && this.senderListForPopulateData.length > 0) && !this.valueToSearchforStatus){
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Value Not Selected', detail: 'Please Select atleast one filter to search.' });
      return false;
    }
    if(this.toDate || this.fromDate){
      if(!this.valueToSearchforStatus){
        this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Value Not Selected', detail: 'Please Select Status for date filter' });
        return false;
      }
    }
    return true;
  }

  private setProperties(result){
    if (result.data && result.data.data) {
      this.populateTableData = result.data.data;
      if(result.data.metadata && result.data.metadata.length > 0){
        this.notificationOfMoreData=result.data.metadata[0].total > 250 ? true:false;
      }
  }
  }

  private handleError(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }
  getinvoicedbatches(event:any){
    if(event){
      this.includeInvoicedBatches=true
    }else {
      this.includeInvoicedBatches=false;
    }
  }
  clearTableData(){
    this.valueToSearch="";
    this.valueToSearchforSender=null;
    this.valueToSearchforStatus="";
    this.fromDate=null;
    this.toDate=null;
    this.populateTableData=[];
    this.selectedSearchFilter = "BatchId";
    this.isSelected=false;
    this.statusDisabled = true;
    this.senderListForPopulateData = [];
    this.setRowdataforExport=[];
    this.setParsedRowData=[];
    this.includeInvoicedBatches = false;
  }
 
  getTextCellValue(field: string, batch: any){
    if( batch[field] && (field === 'deliveryTargetDateTime' || field === 'batchReceivedDateTime' || field === 'deliveryDate')){
      return this.datepipe.transform(batch[field].$date, this.selectedLab.lab.dateFormat);
    } else if(batch[field] && field === 'statusOfTheBatch') {
      if(batch[field] !== 'INVOICED'){
        batch['unitPrice'] = '';
        batch['totalPrice'] = "";
      }
      if(batch['statusChangedDateTime']){
          return this.mapOfStatusCalls.get(batch[field]) + " (" + this.datepipe.transform(batch['statusChangedDateTime'].$date, this.selectedLab.lab.dateFormat) +")";
      }
      return this.mapOfStatusCalls.get(batch[field]);
    } else if(batch[field]) {
      return batch[field];
    }else{
      return '-';
    }
  }
  decideIfBBRoleExists() {
    let roles = this.getRolesFromAccessToken();
    if(roles.length > 0) {
      return (roles.includes(this.blueberryArticKonstanzInvoicingUsers)
        || roles.include(this.blueberryUKDTCPopGenInvoicingUsers)
       );
    }
    return false;
  }
  getRolesFromAccessToken() {
    let authUtil = new AuthUtil()
    let accessToken = authUtil.getAccessToken()
    if(accessToken)
    {
      let access_token = jwt_decode(accessToken);
      return access_token.roles;
    }
    return [];
  }
  closedialogBox(){
    this.notificationOfMoreData=false
  }

  changeStatus(){
    this.statusDisabled = false;
  }

  exportToExcelCheck(){
    this.rowDataCheck=true;
    this.customerExport=true;
  }

  setdownloadOption(){
    if(this.rowDataCheck && this.senderDataCheck){
      this.downloadOption="Both";
    }else if(this.rowDataCheck){
      this.downloadOption="RowData";
    }else if(this.senderDataCheck){
      this.downloadOption="Sendertype";
    }
  }

  exportToExcel() {
    if(!this.rowDataCheck && !this.senderDataCheck){
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Export Option Not Selected', detail: 'Please select at least one export option.' });
      return;
    }
    let today = new Date();
    let current_date: Date = new Date();
    let dateString = this.datepipe.transform(today, 'yyyyMMdd_HHmmss');
    this.convertDateToString();
    this.setdownloadOption();
    let dataToExport = {"puid": this.puid,"exportedDate":dateString,"labId":this.selectedLabId,"downloadOption":this.downloadOption, "dataList": this.setParsedRowData,"validRole":this.validRole};
    this.blocked = true;
    this.customerTrackService.exportExcelExportForBatchData(dataToExport).subscribe(
      result => {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Excel downloaded successfully',
          detail: '',
        });
        var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        saveByFileSaver(blob, 'ArticExport_' + this.datepipe.transform(current_date, 'dd_MM_yy') + ".xlsx");
        this.blocked = false;
        this.customerExport=false;
        this.setRowdataforExport=[];
        this.setParsedRowData=[];
        this.selectedRows = [];
        this.senderDataCheck=false;
      },
      error => {
        this.setRowdataforExport=[];
        this.setParsedRowData=[];
        this.selectedRows = [];
        this.blocked = false;
        this.senderDataCheck=false;
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Download Failed!!',
          detail:'Error occured while exporting data to excel.... Please refresh & try again!'
        })
      }
    
      )
    }
    

    addToSelectedRows(data: any){
      this.setRowdataforExport.push(data.data);
    }

    removeFromSelectedMap(data: any){
      let index = this.setRowdataforExport.findIndex(x => x.batchID === data.data.batchID);
        if(index != -1) {
        this.setRowdataforExport.splice(index,1);
        }
    }

  convertDateToString(){
    this.setRowdataforExport.forEach(dataCheck=>{
      let custData={...dataCheck}
      custData.statusOfTheBatch=this.mapOfStatusCalls.get(custData.statusOfTheBatch);
      custData.deliveryTargetDateTime=custData.deliveryTargetDateTime?this.datepipe.transform(custData.deliveryTargetDateTime.$date, 'dd/MM/yy'):"";
      custData.batchReceivedDateTime=custData.batchReceivedDateTime?this.datepipe.transform(custData.batchReceivedDateTime.$date, 'dd/MM/yy'):"";
      custData.deliveryDate=custData.deliveryDate?this.datepipe.transform(custData.deliveryDate.$date, 'dd/MM/yy'):"";
      custData.statusChangedDateTime=custData.statusChangedDateTime?this.datepipe.transform(custData.statusChangedDateTime.$date, 'dd/MM/yy'):"";
      this.setParsedRowData.push(custData);
    })
  }

  getStyle(field){
      if(field == "statusOfTheBatch"){
        return {width: '13rem',height: '2.6rem'};
      } else{
        return {width: '10rem',height: '2.6rem'};
      }
  }

  getTextCellUnitTotalPrice(field: string, batch: any){
    return batch[field];
  }
  onTableHeaderCheckboxToggle(event:any){
    if (event.checked){
      this.populateTableData.forEach(element => {
        this.setRowdataforExport.push(element)
      });
    }else{
      this.setRowdataforExport=[];
    }

  }
}
